import { convertTimelapseModel, Timelapse, timelapseUpdateSchema, TimelapseUpdateSchema } from "@/lib/types/timelapse"
import { Button, Group, Stack, Textarea, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";
import { zod4Resolver } from "mantine-form-zod-resolver";

type Props = {
  timelapse: Timelapse;
  onSubmit: (timelapse: TimelapseUpdateSchema) => void;
  close: () => void;
}

export const TimelapseFormUpdate = ({ timelapse, onSubmit, close }: Props) => {
  const form = useForm<TimelapseUpdateSchema>({
    initialValues: convertTimelapseModel(timelapse),
    validate: zod4Resolver(timelapseUpdateSchema),
  })

  const handleSubmit = () => {
    if (form.validate().hasErrors) return

    onSubmit(form.values)
  }

  return (
    <Stack>
      <TextInput
        label="Name"
        placeholder="Dandelion"
        {...form.getInputProps("name")}
      />
      <Textarea
        label="Description"
        placeholder="A purple dandelion"
        autosize
        minRows={2}
        maxRows={6}
        {...form.getInputProps("description")}
      />
      <Group justify="end">
        <Button onClick={close} variant="outline">
          Cancel
        </Button>
        <Button onClick={handleSubmit}>
          Submit
        </Button>
      </Group>
    </Stack>
  )
}
